module.exports = __webpack_public_path__ + "media/newstyle/images/quadrado-46edd10b0b39b90af2af8bbe854f9635.svg";